import { AUTHORIZATION } from 'http-header-fields';

import BaseProvider, { normalizeAccessObject, onLoginSymbol } from './BaseProvider';
import { createIdentity, createAccessObject } from './JWTProvider';

const tulipAuthHeader = 'TulipAuth';

const symbols = {
  bridge: Symbol('Bridge instance property'),
};

export default class BridgeProvider extends BaseProvider {
  constructor(bridge, options) {
    super(options);

    this[symbols.bridge] = bridge;
  }

  async init(options) {
    await super.init(options);

    if (this.getIdentity()) {
      await this[onLoginSymbol]();
    }

    return this;
  }

  async login() {
    await this.renew();
    this[onLoginSymbol]();

    return this.getIdentity();
  }

  async renew() {
    const bridge = this[symbols.bridge];
    const fallbackRenewFunctionName = 'requestNewTulipAuthToken';
    const renewFunctionName = 'requestNewTulipOpenIDConnectAuthToken';

    await new Promise(resolve => bridge.call(
      bridge.get(renewFunctionName) ? renewFunctionName : fallbackRenewFunctionName, resolve),
    );

    return this.getAccessObject();
  }

  getIdentity() {
    const { idToken } = this.getAccessObject();

    return createIdentity(idToken);
  }

  getAccessObject() {
    const bridge = this[symbols.bridge];
    const fallbackAccessObject = createAccessObject(
      bridge.get('tulipauth_token', null),
    );

    return normalizeAccessObject(bridge.get('tulipAuth', fallbackAccessObject));
  }

  getRequestHeaders() {
    const { authType, idToken, accessToken } = this.getAccessObject();
    const headers = {};

    if (authType === 'jwt' && idToken) {
      headers[tulipAuthHeader] = idToken;
    }

    if (authType === 'openid' && accessToken) {
      headers[AUTHORIZATION] = `Bearer ${accessToken}`;
    }

    return headers;
  }
}



// WEBPACK FOOTER //
// ./src/Auth/providers/BridgeProvider.js